import axios from "axios";
import { jwtDecode } from "jwt-decode";

const baseURL = process.env.REACT_APP_API_BASE_URL;

export const getAtendimentosCliente = async ({
  idCliente,
  dias,
  dataInicio,
  dataFim,
} = {}) => {
  const token = localStorage.getItem("jwtToken");
  if (!token) {
    throw new Error("Token nao encontrado no localStorage.");
  }

  let resolvedIdCliente = idCliente;
  if (!resolvedIdCliente) {
    try {
      const decoded = jwtDecode(token);
      resolvedIdCliente = decoded?.id_cliente;
    } catch (error) {
      throw new Error("Erro ao decodificar token para idCliente.");
    }
  }

  if (!resolvedIdCliente) {
    throw new Error("ID do cliente nao encontrado no token.");
  }

  const params = {
    idClienteAipim: resolvedIdCliente,
    ...(dias != null ? { dias } : {}),
    ...(dataInicio ? { dataInicio } : {}),
    ...(dataFim ? { dataFim } : {}),
  };

  const response = await axios.get(
    `${baseURL}/produto/sdr/atendimentos-cliente`,
    {
      params,
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return response.data;
};
